module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av535-a2918378c3a5e0854d49dc2fadc228e6.jpg";